var WDN = WDN || {};

if (typeof WDN.SearchTemplate === "undefined") {
  WDN.SearchTemplate = (function () {
    var init, readQuery, setModalQuery;

    var readQuery = function () {
      return document.querySelector("[data-search-terms]").getAttribute("data-search-terms");
    };

    var StickySupport = {
      render: function () {
        if (window.innerWidth < 1900) return;
        new WDN.SectionRenderer({
          selectors: {
            output: "[data-search-support-content]",
          },
          sections: ["async-collection-support"],
          useCurrentRoot: true,
          stripWrapper: true,
          triggers: [window],
          events: ["load"],
        });
      },
    };

    var Filters = {
      render: function () {
        new WDN.SectionRenderer({
          selectors: {
            output: "[data-search-filters-content]",
          },
          autoInit: true,
          useCurrentRoot: true,
          replaceOutput: true,
          stripWrapper: true,
          sections: ["async-search-filters"],
          callback: function () {
            new WDN.Filters();
            WDN.RangeSlides.reInit();
            // Load filter modal
            Filters.modalInit();

            this.rendered = true;
          }.bind(this),
        });
      },

      modalInit: function () {
        // Filter modal async
        var filterModalTrigger = document.querySelector("wdn-modal-open[data-id='collection_filters']");
        var filterModalTriggerPagination = document.querySelector(".search-pagination wdn-modal-open[data-id='collection_filters']");
        var slideToSortBy = document.querySelector("[data-slide-to='sort_by']");
        var initiator = false;

        var FilterModalRenderer = new WDN.SectionRenderer({
          selectors: {
            output: "[data-filter-modal-content]",
          },
          triggers: [filterModalTrigger, filterModalTriggerPagination, slideToSortBy],
          useCurrentRoot: true,
          stripWrapper: true,
          sections: ["async-filter-modal"],
          events: ["click"],
          callback: function () {
            WDN.RangeSlides.reInit();

            // Save and close modal button
            var saveAndCloseButtons = document.querySelectorAll(".filter-modal-controls wdn-modal-close");

            // When save & close button clicked in modal - scroll to top
            saveAndCloseButtons.forEach(function (button) {
              button.addEventListener("click", function () {
                window.scroll(0, 0);
              });
            });

            if (initiator !== slideToSortBy) return;
            // Since sortby was clicked, swipe to that slide
          },
        });

        var handleSlideToSortClick = function () {
          if (FilterModalRenderer.complete) {
            // Since the content is injected, we don't need this event listener anymore
            slideToSortBy.removeEventListener("click", handleSlideToSortClick);
            return;
          }
          // store initiator so we can swipe to correct slide on render
          initiator = slideToSortBy;

          // Open filter modal
          filterModalTrigger.click();
        };

        // Only because its functionality doesn't exist until the content is injected in modal
        slideToSortBy ? slideToSortBy.addEventListener("click", handleSlideToSortClick) : "";

        var handleFiltersUpdate = function () {
          // Once filter modal is rendered, stop listening for updates
          if (FilterModalRenderer.complete) {
            document.removeEventListener("filters:fetch:success", handleFiltersUpdate);
          }

          FilterModalRenderer.unbind();
          FilterModalRenderer.config.triggers = false;
          //  [ON MOBILE] ... Eller filtrer produkterne her - rerenders every time filters are added

          FilterModalRenderer.config.selectors.trigger = ".search-pagination wdn-modal-open[data-id='collection_filters']";
          FilterModalRenderer.storeNodes();
          FilterModalRenderer.bind();
        };

        // Listen for filters update
        document.addEventListener("filters:fetch:success", handleFiltersUpdate);
      },
    };

    var Recommendations = {
      getSwiperClone: function () {
        var template = document.querySelector('[data-search-template="suggestion-swiper"]');
        return template.content.cloneNode(true);
      },
      render: async function () {
        var query = readQuery();
        var searchParams = new URLSearchParams();

        // General Search params - shared between collections and articles/pages
        searchParams.set("q", query);

        // Search params - collection specific
        searchParams.set("section_id", "async-search-collections");
        searchParams.set("resources[type]", "collection");
        /* Search for collections */
        var collections = await fetch(Shopify.routes.root + "search/suggest?" + searchParams.toString());

        // Search params - article/page specific
        searchParams.delete("section_id");
        searchParams.delete("resources[type]");
        searchParams.set("view", "recommendations");
        searchParams.set("type", "article,page");
        /* Search for pages and articles */
        var articles = await fetch(Shopify.routes.root + "search?" + searchParams.toString());

        // If responses not success - stop
        if (!articles.ok || !collections.ok) return;

        // Output array
        var outputList = [];
        var output = document.querySelector("[data-search-recommendations]");
        if (!output) return;

        // DOM Parser - used to parse string response
        var domParser = new DOMParser();

        // Turn response into text
        var collectionResponse = await collections.text();
        var articleResponse = await articles.text();

        // Parse response
        var parsedCollectionResponse = domParser.parseFromString(collectionResponse, "text/html");
        var parsedArticleResponse = domParser.parseFromString(articleResponse, "text/html");

        // Configure collections
        var collectionRecommendations = parsedCollectionResponse.querySelector("[data-recommendations]");
        if (collectionRecommendations) {
          var collectionRecommendationsSlides = collectionRecommendations.querySelectorAll('[data-type="collection"]');
        }

        // Configure article/pages
        var articleRecommendations = parsedArticleResponse.querySelector("[data-recommendations]");
        if (articleRecommendations) {
          var articleRecommendationsSlides = articleRecommendations.querySelectorAll('[data-type="pagearticle"]');
        }

        // Collections output
        if (collectionRecommendations && collectionRecommendationsSlides.length > 0) {
          output.appendChild(collectionRecommendations);
        }

        // Article/pages output
        if (articleRecommendations && articleRecommendationsSlides.length > 0) {
          output.appendChild(articleRecommendations);
        }

        // If no suggestions - hide container
        if (!collectionRecommendationsSlides && !articleRecommendationsSlides) {
          output.classList.add("hidden");
        }
      },
    };

    setModalQuery = function () {
      // Search element
      var searchElement = document.querySelector("search-element");

      // On modal open - Perform search with the current query
      searchElement.setQuery(readQuery());
    };

    // Init
    init = function () {
      Filters.render();
      Recommendations.render();
      StickySupport.render();

      setTimeout(function () {
        setModalQuery();
      }, 600);
    };

    init();

    return {
      Filters,
      Recommendations,
    };
  })();
}
